import { Card } from '@/components/ui/card';
import { MapPin } from 'lucide-react';

export function InteractiveMapPlaceholder() {
  return (
    <Card className="p-6 bg-muted/50">
      <div className="flex items-center gap-2 mb-2">
        <MapPin className="w-5 h-5 text-blue-600" />
        <h3 className="text-lg font-semibold">Interactive Map</h3>
      </div>
      <p className="text-muted-foreground mb-4">
        Full interactive mapping functionality with route visualization will be available in the next version. This will
        include real-time tracking, heat maps, and detailed route analytics.
      </p>
      <div className="aspect-video bg-background rounded-lg border-2 border-dashed flex items-center justify-center">
        <div className="text-center text-muted-foreground">
          <MapPin className="w-12 h-12 mx-auto mb-2 opacity-50" />
          <p>Interactive Map Coming Soon</p>
          <p className="text-sm">Location data and routes will be displayed here</p>
        </div>
      </div>
    </Card>
  );
}
